import { lazy } from 'react';

import { withCampaignSavedData } from './withCampaignSavedData';

const FormPagesStep04 = lazy(() => import('@features/campaigns/builder/containers/FormPages/Step04/Step04.tsx'));

export const EnhancedFormPagesStep04 = withCampaignSavedData(FormPagesStep04);
